module.exports = __webpack_public_path__ + "img/my-assets.a7a06bfd.svg";